export const reducerType = 'searchBookings';

const defaultState = {};

// Holds: location, startDate, startTime, endDate, endTime, usageTypes, vehicleType, motorisation, transmission, accessories, places, voucherCode, tripType.
export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case `${reducerType}/SET_SEARCH_VALUES`: {
      state = {
        ...state,
        ...action.payload
      };
      break;
    }

    case `${reducerType}/CLEAR`: {
      state = {};
      break;
    }

    default: {
      break;
    }
  }

  return state;
}
